import React, { useMemo } from 'react';

import FieldHistoryPanel from '~/components/Offers/Detail/OfferBuilder/shared/fieldHistory/FieldHistoryPanel';
import { newestOfCountLabel } from '~/components/Offers/Detail/OfferBuilder/shared/fieldHistory/newestOfCountLabel';
import { toFieldHistoryEntries } from '~/components/Offers/Detail/OfferBuilder/shared/fieldHistory/toFieldHistoryEntries';

import { useGetCaseFieldHistory } from '~/hooks/apis/contracting/useGetCaseFieldHistory';

const CASE_HISTORY_PAGE_SIZE = 100;

interface Props {
  caseNumber: string;
}

export default function CaseHistoryCard({ caseNumber }: Props) {
  const { data: history, error, isLoading } = useGetCaseFieldHistory(caseNumber, { limit: CASE_HISTORY_PAGE_SIZE });
  const entries = useMemo(() => toFieldHistoryEntries(history?.result ?? []), [history]);
  const totalCount = history?.pagination.total_items ?? 0;

  return (
    <FieldHistoryPanel
      chipLabel={history ? newestOfCountLabel('change', entries.length, totalCount) : undefined}
      entries={entries}
      error={error}
      isLoading={isLoading}
      title="Case History"
      totalCount={totalCount}
    />
  );
}
